import React from 'react';
import styles from './ThankYou.module.css';
import cx from 'classnames';

interface ThankYouProps {
    isActive?: boolean;
}

const ThankYou: React.FC<ThankYouProps> = ({ isActive = false }) => {
    return (
        <div className={cx(styles['thank-you-container'])} hidden={!isActive}>
            <div className={styles['thank-you-card']}>
                <div className={styles['thank-you-icon']}>
                    <svg
                        width="80"
                        height="80"
                        viewBox="0 0 80 80"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden
                    >
                        <circle cx="40" cy="40" r="38" stroke="currentColor" strokeWidth="2" fill="none" />
                        <path
                            d="M24 40l10 10 22-22"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <h2 className={styles['thank-you-title']}>Vielen Dank!</h2>
                <p className={styles['thank-you-message']}>
                    Wir haben Ihre Anfrage erhalten und melden uns in Kürze bei Ihnen.
                </p>
                <p className={styles['thank-you-message']}>
                    Ihr Zugang wird nun von unserem Team geprüft. Sobald Ihr Konto freigeschaltet ist, kontaktieren wir
                    Sie. Der Zugriff auf den Shop ist erst nach der Freischaltung möglich.
                </p>
                <p className={styles['thank-you-sub']}>
                    Bei Fragen erreichen Sie uns unter{' '}
                    <a href="mailto:info@ts-workwear.de" className={styles['thank-you-email']}>
                        info@ts-workwear.de
                    </a>
                </p>
            </div>
        </div>
    );
};

export default ThankYou;
